export default {
    'ΑΝΕΥ ΟΠΛΟΥ':	'ΑΟ',
    'ΑΓΝΩΣΤΟΥ ΟΠΛΟΥ - ΣΩΜΑΤΟΣ':	'ΑΓΝΩΣΤΟ',
    'ΠΕΖΙΚΟ':	'ΠΖ',
    'ΠΥΡΟΒΟΛΙΚΟ':	'ΠΒ',
    'ΤΕΘΩΡΑΚΙΣΜΕΝΑ':	'ΤΘ',
    'ΜΗΧΑΝΙΚΟ':	'ΜΧ',
    'ΔΙΑΒΙΒΑΣΕΙΣ':	'ΔΒ',
    'ΚΑΤΑΔΡΟΜΕΣ':	'ΚΔ',
    'ΣΤΡΑΤΟΝΟΜΙΑ':	'ΣΝ',
    'ΟΙΟΥΔΗΠΟΤΕ ΟΠΛΟΥ-ΣΩΜΑΤΟΣ':	'ΟΟΣ',
    'ΠΕΖΟΝΑΥΤΕΣ':	'Π/Ν',
    'ΑΕΡΟΠΟΡΙΑ ΣΤΡΑΤΟΥ':	'ΑΣ',
    'ΕΦΟΔΙΑΣΜΟΥ-ΜΕΤΑΦΟΡΩΝ':	'ΕΜ',
    'ΥΓΕΙΟΝΟΜΙΚΟ':	'ΥΓ',
    'ΤΕΧΝΙΚΟ':	'ΤΧ',
    'ΥΛΙΚΟΥ ΠΟΛΕΜΟΥ':	'ΥΠ',
    'ΟΙΚΟΝΟΜΙΚΟ':	'Ο',
    'ΔΙΚΑΣΤΙΚΟ':	'ΔΚ',
    'ΝΟΜΙΚΟΥ ΣΩΜΑΤΟΣ':	'ΝΟΜ',
    'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΘΕΩΡΗΤΩΝ':	'ΟΕ',
    'ΓΕΩΓΡΑΦΙΚΟ':	'Γ',
    'ΕΡΕΥΝΑΣ ΠΛΗΡΟΦΟΡΙΚΗΣ':	'ΕΠ',
    'ΤΑΧΥΔΡΟΜΙΚΟ':	'ΤΔ',
    'ΜΟΥΣΙΚΟ':	'ΜΣ',
    'ΣΤΡΑΤΙΩΤΙΚΩΝ ΙΕΡΕΩΝ':	'ΣΙ',
    'ΣΤΡΑΤΙΩΤΙΚΩΝ ΓΡΑΜΜΑΤΕΩΝ-ΔΙΕΡΜΗΝΕΩΝ':	'ΣΓ',
    'ΓΕΝΙΚΕΣ':	'ΓΕΝ',
    'ΕΠΙΤΕΛΕΙΑ':	'ΕΠΙΤΕ',
    'ΣΤΡΑΤΗΓΕΙΑ':	'ΣΤΡΑ',
    'ΜΟΝ.ΚΥΒ.ΚΛΙΜΑΚ.':	'Μ.Κ.Κ',
    'ΣΧΟΛΕΣ ΚΕΝΤΡΑ':	'ΣΧΟΛ',
    'ΜΟΝΑΔΕΣ ΕΠΙΣΤΡΑΤΕΥΣΗΣ':	'Μ.ΕΠ',
    'Τ.ΕΘΝΟΦΥΛΑΚΗΣ':	'Τ/ΕΘ',
    'ΔΙΑΦΟΡΕΣ ΜΟΝΑΔΕΣ':	'ΔΙΑΦ',
    'ΟΙΟΥΔΗΠΟΤΕ ΟΠΛΟΥ':	'ΟΟ',
    'ΟΙΟΥΔΗΠΟΤΕ ΣΩΜΑΤΟΣ':	'Ο-Σ',
    'ΕΙΔΙΚΗΣ ΚΑΤΑΣΤΑΣΕΩΣ':	'ΕΚ',
    'ΟΠΟΙΟΥΔ. ΟΠΛ. - ΕΙΔ.ΜΟΝΙΜΟΤΗΤΟΣ':	'ΟΟΕΜ',
    'ΛΟΙΠΑ':	'ΛΠΑ',
    'DOR':	'DOR'
  }